export default "__VITE_ASSET__DtMG$0Vl__"